import gql from 'graphql-tag';

export const ListApplicationsQuery = gql`
  query ListApplicationsQuery {
    applications {
      id
      applicationNumber
      name
      _Ebb_DwellingId
      _Ebb_DwellingId_Formatted
      _Ebb_OwnerId
      _Ebb_OwnerId_Formatted
      _Ebb_ProgramCycleId
      _Ebb_ProgramCycleId_Formatted
      _Ebb_PolicyId
      programType
      sGStatus
      stageCode
      stageCodeOptionSet
      stateCode
      stateCodeOptionSet
      statusCode
      statusCodeOptionSet
      acceptedDate
      preRetrofitDue
      preRetrofitPass
      postRetrofitDue
      postRetrofitPass
      applicationStatus
      applicationStatusOptionSet
      extensionDate
      eventPreliminaryReviewApproval
      eventPreliminaryReview
      eventFemaReview
      eventApplicationSubmitted
      eventMitigationReviewSubmitted
      eventFinancialReviewSubmitted
      _Ebb_ContractorId
      _Ebb_ContractorId_Formatted
      _Ebb_LdpId
      _Ebb_LdpId_Formatted
      contractorTypeCode
      contractorTypeCodeOptionSet
      contractorPermissionsCode
      contractorPermissionsCodeOptionSet
      contractorInvitationCode
      contractorInvitationCodeOptionSet
      contractorInvitationDate
      contractorBidAmount1
      contractorBidAmount1Selected
      contractorBidAmount2
      contractorBidReason
      ldpBidAmount1
      ldpBidAmount1Selected
      ldpBidAmount2
      ldpBidReason
      permitIssuedDate
      permitIssuer
      permitNumber
      permitPlanCode
      permitPlanCodeOptionSet
      w9DataSubmitted
      paymentDataSubmitted
      retrofitConstructionStartDate
      retrofitConstructionEndDate
      retrofitConstructionNumberOfDays
      itemsPendingRollup
      itemsUpdatedRollup
      itemsRejectedRollup
      submissionRejection
      inspectorFullname
      inspectionDate
      ebbInspectionStatus
      ebbInspectorName
      ebbInspectionDate
      programCycle {
        multipleBidsRequired
        bidMustSubmitDoc
        homeownerOccupied
        multipleDwellings
        contractorAllowManual
        engineeredBidMustSubmitDoc
        multipleEngineeredBidsRequired
        maxBidAmount
        maxEngineeredBidAmount
      }
      contractor {
        id
        businessName
      }
      dwelling {
        homeownerOccupied
        withdrawnDate
        withdrawReason
      }
      owner{
      id
      emailAddress1
      telephone1
      }  
    }
  }
`;

export const ListApplicationsProgramCycleQuery = gql`
  query ListApplicationsProgramCycleQuery {
    applications {
      id
      applicationNumber
      name
      programCycle {
        multipleBidsRequired
        bidMustSubmitDoc
        homeownerOccupied
        multipleDwellings
        contractorAllowManual
        engineeredBidMustSubmitDoc
        multipleEngineeredBidsRequired
        maxBidAmount
        maxEngineeredBidAmount
      }
      dwelling {
        homeownerOccupied
      }
    }
  }
`;

export const ListInspectionCompleteApplicationsQuery = gql`
  query ListApplicationsQuery {
    applications(type: "inspectionComplete") {
      id
      applicationNumber
      name
      _Ebb_DwellingId
      _Ebb_DwellingId_Formatted
      _Ebb_OwnerId
      _Ebb_OwnerId_Formatted
      _Ebb_ProgramCycleId
      _Ebb_ProgramCycleId_Formatted
      _Ebb_PolicyId
      programType
      stageCode
      stageCodeOptionSet
      stateCode
      stateCodeOptionSet
      statusCode
      statusCodeOptionSet
      acceptedDate
      preRetrofitDue
      preRetrofitPass
      postRetrofitDue
      postRetrofitPass
      eventPreliminaryReview
      eventFemaReview
      applicationStatus
      applicationStatusOptionSet
      extensionDate
      eventApplicationSubmitted
      eventMitigationReviewSubmitted
      eventFinancialReviewSubmitted
      _Ebb_ContractorId
      _Ebb_ContractorId_Formatted
      _Ebb_LdpId
      _Ebb_LdpId_Formatted
      contractorTypeCode
      contractorTypeCodeOptionSet
      contractorPermissionsCode
      contractorPermissionsCodeOptionSet
      contractorInvitationCode
      contractorInvitationCodeOptionSet
      contractorInvitationDate
      contractorBidAmount1
      contractorBidAmount1Selected
      contractorBidAmount2
      contractorBidReason
      ldpBidAmount1
      ldpBidAmount1Selected
      ldpBidAmount2
      ldpBidReason
      permitIssuedDate
      permitIssuer
      permitNumber
      permitPlanCode
      permitPlanCodeOptionSet
      w9DataSubmitted
      paymentDataSubmitted
      retrofitConstructionStartDate
      retrofitConstructionEndDate
      retrofitConstructionNumberOfDays
      itemsPendingRollup
      itemsUpdatedRollup
      itemsRejectedRollup
      submissionRejection
      inspectorFullname
      inspectionDate
      ebbInspectionStatus
      ebbInspectorName
      ebbInspectionDate
      programCycle {
        multipleBidsRequired
        bidMustSubmitDoc
        homeownerOccupied
        multipleDwellings
        contractorAllowManual
        engineeredBidMustSubmitDoc
        multipleEngineeredBidsRequired
        maxBidAmount
        maxEngineeredBidAmount
      }
      contractor {
        id
        businessName
      }
      dwelling {
        homeownerOccupied
      }
    }
  }
`;

export const ListApplicationsForMultipleQuery = gql`
  query ListApplicationsQuery {
    applications {
      stateCode
      statusCode
      _Ebb_ProgramCycleId
    }
  	dwellings {
      stateCode
      statusCode
      _Ebb_ProgramCycleId
    }
  }
`;

export const GetApplicationByIdQuery = gql`
         query GetApplicationByIdQuery($id: String) {
           application(id: $id) {
             id
             applicationNumber
             name
             _Ebb_DwellingId
             _Ebb_DwellingId_Formatted
             _Ebb_OwnerId
             _Ebb_OwnerId_Formatted
             _Ebb_ProgramCycleId
             _Ebb_ProgramCycleId_Formatted
             _Ebb_PolicyId
             programType
             programRulesAcknowledged
             stageCode
             stageCodeOptionSet
             stateCode
             stateCodeOptionSet
             statusCode
             statusCodeOptionSet
             acceptedDate
             acknowledgedDate
             sgAcknowledgedDate
             preRetrofitDue
             preRetrofitPass
             postRetrofitDue
             postRetrofitPass
             eventFemaReviewOptionSet
             applicationStatus
             applicationStatusOptionSet
             extensionDate
             eventPreliminaryReviewApproval
             eventPreliminaryReview
             eventFemaReview
             eventApplicationSubmitted
             eventMitigationReviewSubmitted
             eventFinancialReviewSubmitted
             _Ebb_ContractorId
             _Ebb_ContractorId_Formatted
             _Ebb_LdpId
             _Ebb_LdpId_Formatted
             contractorTypeCode
             contractorTypeCodeOptionSet
             contractorPermissionsCode
             contractorPermissionsCodeOptionSet
             contractorInvitationCode
             contractorInvitationCodeOptionSet
             contractorInvitationDate
             contractorBidAmount1
             contractorBidAmount1Selected
             contractorBidAmount2
             contractorBidReason
             ldpBidAmount1
             ldpBidAmount1Selected
             ldpBidAmount2
             ldpBidReason
             permitIssuedDate
             permitIssuer
             permitNumber
             permitPlanCode
             permitPlanCodeOptionSet
             w9DataSubmitted
             paymentDataSubmitted
             retrofitConstructionStartDate
             retrofitConstructionEndDate
             retrofitConstructionNumberOfDays
             itemsPendingRollup
             itemsUpdatedRollup
             itemsRejectedRollup
             submissionRejection
             retrofitType
             retrofitTypeOptionSet
             engineeredSolutionType
             engineeredSolutionTypeOptionSet
             permitCost
             materialCost
             laborCost
             overheadProfitCost
             bidInvoiceCost
             engineeredPlanCost
             engineerFeeCost
             inspectorFullname
             inspectionDate
             ebbInspectionStatus
             ebbInspectorName
             ebbInspectionDate
             sGStatus
             sGStatusOptionSet
             sGBidInvoiceNeeded
             sGBidInvoiceNeededHomeowner
             sGBidInvoiceSubmitted
             sGPermitReceiptSubmitted
             sGPermitReceiptSubmittedHomeowner
             sg4506CRequestType
             sg4506CRequestTypeOptionSet
             envelopeOkToVerify
             envelopeId
             sGSubmittedDate
             sGmaxrequests
             sGHomeownerPaidPermit
             sGPermitPaidDate
             sGBuildingPermitProcessing
             sGBidInvoiceProcessing
             drvEligible
             approvalTasks {
               id
               name
               stageCode
               stageCodeOptionSet
               stateCode
               stateCodeOptionSet
               statusCode
               statusCodeOptionSet
               uiTabName
               userPrompt
               progressReport
               dueDateSuggested
               itemCountTotal
               itemCountDone
               approvalTaskItems {
                 id
                 name
                 typeCode
                 typeCodeOptionSet
                 stateCode
                 stateCodeOptionSet
                 statusCode
                 statusCodeOptionSet
                 reasonWhy
                 allowRecordCreation
                 isRequired
                 payloadTypeCode
                 payloadTypeCodeOptionSet
                 payloadName
                 payload
                 submitDate
                 submissionReject
                 ebbModifiedDate
                 ebbModifiedByTypeOptionSet
                 approvalTaskItemKey
                 createdOn
                 attempt
                 taxYear
                 annotations {
                   id
                   fileName
                   modifiedOn
                   noteText
                 }
                 recipients {
                   id
                   clientId
                   documentId
                   recipientId
                   primary
                   name
                   nameFirst
                   nameMiddle
                   nameLast
                   verificationStatus
                   verificationStatusDescription
                   verificationSubmitted
                   verificationCompleted
                   verificationErrorDate
                   viewUrl
                   statusCode
                   signingStatus
                   signingDate
                   recipientStatus
                   recipientStatusOptionSet
                   _Ebb_ApprovalTaskItemId
                   sg4506CRequestType
                   sg4506CRequestTypeOptionSet
                 }
               }
             }
             programCycle {
               multipleBidsRequired
               bidMustSubmitDoc
               homeownerOccupied
               contractorAllowManual
               engineeredBidMustSubmitDoc
               multipleEngineeredBidsRequired
               maxBidAmount
               maxEngineeredBidAmount
             }
             policy {
               expirationDate
             }
             contractor {
               id
               businessName
               contractorManualEntry
               fullName
               contractorInDirectory
               essContractorInDirectory
               emrContractorInDirectory
             }
             contractorHireHistorys {
               createdOn
               contractorid
               contractorBusinessName
             }
             applicationEvents {
               createdOn
               eventType
               eventDescription
             }
               dwelling {
        homeownerOccupied
        withdrawnDate
        withdrawReason
        ownerAssociation
            }
           }
         }
       `;
